/* 

PODER POR RAREZA:
    SUITS:           S  /  A
        COMMON:     110 / 100
        RARE:       220 / 200
        EPIC:       330 / 300
        LEGENDARY:  440 / 400

    WEAPONS:         S  /  A
        COMMON:     100 / 110
        RARE:       200 / 220
        EPIC:       300 / 330
        LEGENDARY:  400 / 440

*/

export const calculateItemStats = (rarity, power, itemType, nation) => {

    if(nation === 'Silkhs'){
        if(itemType === 'suits'){
            if(rarity === 'Common'){
                const weightL = Math.round((((140 / Number(power))*100)/ 440)*100);
                const radiationR = Math.round((((100 / Number(power))*100)/ 440)*100);
                const energyC = Math.round((((310 / Number(power))*100)/ 440)*100);
                
                const stats = {
                    weightL: weightL,
                    radiationR: radiationR,
                    energyC: energyC,
                }
                return stats
            }
            else if(rarity === 'Rare'){
                const weightL = Math.round((((370 / Number(power))*100)/ 440)*100);
                const radiationR = Math.round((((280 / Number(power))*100)/ 440)*100);
                const energyC = Math.round((((300 / Number(power))*100)/ 440)*100);
                
                const stats = {
                    weightL: weightL,
                    radiationR: radiationR,
                    energyC: energyC,
                }
                
                return stats
            }
            else if(rarity === 'Epic'){
                const weightL = Math.round((((900 / Number(power))*100)/ 440)*100);
                const radiationR = Math.round((((1010 / Number(power))*100)/ 440)*100);
                const energyC = Math.round((((239 / Number(power))*100)/ 440)*100);
                
                const stats = {
                    weightL: weightL,
                    radiationR: radiationR,
                    energyC: energyC,
                }
                
                return stats
            }
            else if(rarity === 'Legendary'){
                const weightL = Math.round((((1700 / Number(power))*100)/ 440)*100);
                const radiationR = Math.round((((1600 / Number(power))*100)/ 440)*100);
                const energyC = Math.round((((230 / Number(power))*100)/ 440)*100);
                
                const stats = {
                    weightL: weightL,
                    radiationR: radiationR,
                    energyC: energyC,
                }
                
                return stats
            }
        }
        else if(itemType === 'weapons'){
            if(rarity === 'Common'){
                const utility = Math.round((((110 / Number(power))*100)/ 440)*100); // 25
                const lethality = Math.round((((110 / Number(power))*100)/ 440)*100); // 25
                const attack = Math.round((((120 / Number(power))*100)/ 440)*100); // 27
                
                const stats = {
                    utility: utility,
                    lethality: lethality,
                    attack: attack,
                }
                return stats
            }
            else if(rarity === 'Rare'){
                const utility = Math.round((((290 / Number(power))*100)/ 440)*100); // 33
                const lethality = Math.round((((340 / Number(power))*100)/ 440)*100); // 39
                const attack = Math.round((((360 / Number(power))*100)/ 440)*100); // 41
                
                const stats = {
                    utility: utility,
                    lethality: lethality,
                    attack: attack,
                }
                return stats
            }
            else if(rarity === 'Epic'){
                const utility = Math.round((((800 / Number(power))*100)/ 440)*100); // 61
                const lethality = Math.round((((900 / Number(power))*100)/ 440)*100); // 68
                const attack = Math.round((((1000 / Number(power))*100)/ 440)*100); // 76
                
                const stats = {
                    utility: utility,
                    lethality: lethality,
                    attack: attack,
                }
                return stats
            }
            else if(rarity === 'Legendary'){
                const utility = Math.round((((1390 / Number(power))*100)/ 440)*100); // 79
                const lethality = Math.round((((1350 / Number(power))*100)/ 440)*100); // 77
                const attack = Math.round((((1420 / Number(power))*100)/ 440)*100); // 81
                
                const stats = {
                    utility: utility,
                    lethality: lethality,
                    attack: attack,
                }
                return stats
            }
        }
    }
    else if(nation === 'Arakneths'){
        if(itemType === 'suits'){
            if(rarity === 'Common'){
                const weightL = Math.round((((115 / Number(power))*100)/ 440)*100); // 26
                const radiationR = Math.round((((85 / Number(power))*100)/ 440)*100); // 19
                const energyC = Math.round((((285 / Number(power))*100)/ 440)*100); // 65
                
                const stats = {
                    weightL: weightL,
                    radiationR: radiationR,
                    energyC: energyC,
                }
                return stats
            }
            else if(rarity === 'Rare'){
                const weightL = Math.round((((319 / Number(power))*100)/ 440)*100); // 36
                const radiationR = Math.round((((230 / Number(power))*100)/ 440)*100); // 26
                const energyC = Math.round((((280 / Number(power))*100)/ 440)*100); // 32
                
                const stats = {
                    weightL: weightL,
                    radiationR: radiationR,
                    energyC: energyC,
                }
                
                return stats
            }
            else if(rarity === 'Epic'){
                const weightL = Math.round((((770 / Number(power))*100)/ 440)*100); // 58
                const radiationR = Math.round((((900 / Number(power))*100)/ 440)*100); // 68
                const energyC = Math.round((((239 / Number(power))*100)/ 440)*100); // 18
                
                const stats = {
                    weightL: weightL,
                    radiationR: radiationR,
                    energyC: energyC,
                }
                
                return stats
            }
            else if(rarity === 'Special'){
                const weightL = Math.round((((1150 / Number(power))*100)/ 440)*100); // 
                const radiationR = Math.round((((1100 / Number(power))*100)/ 440)*100); // 
                const energyC = Math.round((((240 / Number(power))*100)/ 440)*100); // 
                
                const stats = {
                    weightL: weightL,
                    radiationR: radiationR,
                    energyC: energyC,
                }
                
                return stats
            }
            else if(rarity === 'Legendary'){
                const weightL = Math.round((((1450 / Number(power))*100)/ 440)*100); // 82
                const radiationR = Math.round((((1390 / Number(power))*100)/ 440)*100); // 79
                const energyC = Math.round((((250 / Number(power))*100)/ 440)*100); // 14
                
                const stats = {
                    weightL: weightL,
                    radiationR: radiationR,
                    energyC: energyC,
                }
                
                return stats
            }
        }
        else if(itemType === 'weapons'){
            if(rarity === 'Common'){
                const utility = Math.round((((120 / Number(power))*100)/ 440)*100); // 25
                const lethality = Math.round((((125 / Number(power))*100)/ 440)*100); // 26
                const attack = Math.round((((139 / Number(power))*100)/ 440)*100); // 29
                
                const stats = {
                    utility: utility,
                    lethality: lethality,
                    attack: attack,
                }
                return stats
            }
            else if(rarity === 'Rare'){
                const utility = Math.round((((340 / Number(power))*100)/ 440)*100); // 35
                const lethality = Math.round((((390 / Number(power))*100)/ 440)*100); // 40
                const attack = Math.round((((410 / Number(power))*100)/ 440)*100); // 42
                
                const stats = {
                    utility: utility,
                    lethality: lethality,
                    attack: attack,
                }
                return stats
            }
            else if(rarity === 'Epic'){
                const utility = Math.round((((890 / Number(power))*100)/ 440)*100); // 61
                const lethality = Math.round((((1000 / Number(power))*100)/ 440)*100); // 69
                const attack = Math.round((((1120 / Number(power))*100)/ 440)*100); // 77
                
                const stats = {
                    utility: utility,
                    lethality: lethality,
                    attack: attack,
                }
                return stats
            }
            else if(rarity === 'Legendary'){
                const utility = Math.round((((1520 / Number(power))*100)/ 440)*100); // 79
                const lethality = Math.round((((1520 / Number(power))*100)/ 440)*100); // 79
                const attack = Math.round((((1600 / Number(power))*100)/ 440)*100); // 83
                
                const stats = {
                    utility: utility,
                    lethality: lethality,
                    attack: attack,
                }
                return stats
            }
        }
    }
    else if(nation === 'Training Camp'){
        if(itemType === 'suits'){
            if(rarity === 'Special'){
                const weightL = Math.round((((25 / Number(power))*100)/ 440)*100); // 14
                const radiationR = Math.round((((30 / Number(power))*100)/ 440)*100); // 17
                const energyC = Math.round((((200 / Number(power))*100)/ 440)*100); // 114
                
                const stats = {
                    weightL: weightL,
                    radiationR: radiationR,
                    energyC: energyC,
                }
                return stats
            }
        }
        else if(itemType === 'weapons'){
            if(rarity === 'Special'){
                const utility = Math.round((((25 / Number(power))*100)/ 440)*100); // 25
                const lethality = Math.round((((20 / Number(power))*100)/ 440)*100); // 25
                const attack = Math.round((((30 / Number(power))*100)/ 440)*100); // 27
                
                const stats = {
                    utility: utility,
                    lethality: lethality,
                    attack: attack,
                }
                return stats
            }
        }
    }
}


export const iteratorTransacHistory = (data, username) => {

    const amountData = (sender, receiver, amount, symbol) => {
        if(sender === username){
            const result = {
                data: `-${amount} ${symbol}`,
                status: 'extract',
            }
            return result
        }
        else if(receiver === username){
            const result = {
                data: `+${amount} ${symbol}`,
                status: 'insert',
            }
            return result
        }
    }

    return data.map(x => {
        let date = new Date(x.timestamp).toLocaleString('en-GB');
        let trx_id = x.trx_id;
        let from = x.act.data.from;
        let to = x.act.data.to;
        let amount = amountData(from, to, x.act.data.amount, x.act.data.symbol);
        let memo = x.act.data.memo;

        const result = {
            date,
            trx_id,
            from,
            to,
            amount,
            memo,
        };

        return result;
    })
}